export default __webpack_public_path__ + "ebe2d6123be83eefe097393e074d8838.png";